import { isNumber, isString } from 'lodash'

const isStringNumber = (val) => {
  if (!isString(val)) {
    return false
  }
  return !Number.isNaN(Number(val))
}

export function addUnit(value, defaultUnit = 'px') {
  if (!value) return ''
  if (isNumber(value) || isStringNumber(value)) {
    return `${value}${defaultUnit}`
  } else if (isString(value)) {
    return value
  }
}

export const enforceUnit = (style) => {
  if (!style) {
    return {}
  }
  ;(['width', 'maxWidth', 'minWidth', 'height']).forEach((key) => {
    style[key] = addUnit(style[key])
  })

  return style
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/utils/sytle.js